import { render } from "./ImageStackLenta.vue?vue&type=template&id=9c29c378&scoped=true"
import script from "./ImageStackLenta.vue?vue&type=script&lang=js"
export * from "./ImageStackLenta.vue?vue&type=script&lang=js"

import "./ImageStackLenta.vue?vue&type=style&index=0&id=9c29c378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c29c378"]])

export default __exports__